/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function() {
  function updateSoldOutBadges() {
    // Target all Warehouse product items
    const productCards = document.querySelectorAll('.product-item.product-item--vertical');

    productCards.forEach(card => {
      if (card.dataset.soldoutChecked) return;
      card.dataset.soldoutChecked = 'true';

      let isSoldOut = false;
      const jsonEl = card.querySelector('[type="application/json"]');

      // --- Detect sold out ---
      if (jsonEl) {
        try {
          const data = JSON.parse(jsonEl.textContent);
          if (data.available === false || (data.variants && data.variants.every(v => !v.available))) {
            isSoldOut = true;
          }
        } catch (e) {}
      } else {
        const text = card.textContent.toLowerCase();
        if (text.includes('sold out')) {
          isSoldOut = true;
        }
      }

      if (isSoldOut) {
        const existingSale = card.querySelector('.product-label.product-label--on-sale');
        const existingSold = card.querySelector('.product-label.product-label--sold-out');
        if (existingSold) return; // Already added

        // If SALE label exists → replace it
        if (existingSale) {
          existingSale.textContent = 'Sold Out';
        } else {
          // Check if product-item__label-list exists
          let labelList = card.querySelector('.product-item__label-list');
          if (!labelList) {
            labelList = document.createElement('div');
            labelList.className = 'product-item__label-list';
            // insert before image wrapper to keep consistent layout
            const imageWrapper = card.querySelector('.product-item__image-wrapper, .product-item__image, .card__media');
            if (imageWrapper) {
              card.insertBefore(labelList, imageWrapper);
            } else {
              card.insertBefore(labelList, card.firstChild);
            }
          }

          // Create the sold-out label and insert into label list
          const soldOutLabel = document.createElement('div');
          soldOutLabel.className = 'product-label product-label--on-sale';
          soldOutLabel.textContent = 'Sold Out';
          labelList.appendChild(soldOutLabel);
        }
      }
    });
  }

  // Run on page load
  updateSoldOutBadges();

  // Watch for dynamically loaded products (AJAX, filters)
  const observer = new MutationObserver(() => updateSoldOutBadges());
  observer.observe(document.body, { childList: true, subtree: true });
});


